import React from 'react';
import { Icon } from './Icon.js';
export const IconLabel2Check = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M2 17L4 19L9 14", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M23.9141 12L15.9141 20H7.24316L9.24316 18H15.0859L21.0859 12L15.0859 6H4V14.7568L2 12.7568V4H15.9141L23.9141 12Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconLabel2Check.js.map